
import { AppTable } from '@/components';
import type { LiveopsLeaderboardReward } from '@/modules/liveops/leaderboard/types';
import { computed, defineComponent, PropType } from 'vue';
import { RewardFeatures } from '@/common/reward/types';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: 'LiveopsLeaderboardTable',
    components: { AppTable },
    props: {
        rows: { type: Array as PropType<LiveopsLeaderboardReward[]>, required: true },
        total: { type: Number, default: undefined },
        canEdit: { type: Boolean, default: false },
        onRemove: { type: Function as PropType<(leaderboardId: number) => void>, default: undefined },
        onRefresh: { type: Function as PropType<() => void>, default: undefined }
    },
    setup(props) {
        const table: TableConfig<LiveopsLeaderboardReward> = {
            columns: [
                { type: TableColumnType.Text, label: 'To Rank', key: 'toRank' },
                { type: TableColumnType.Option, label: 'Feature', key: 'feature', options: RewardFeatures },
                { type: TableColumnType.RouterLink, label: 'Item', key: 'itemName', to: row => row.itemLink ?? '' },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: LiveopsLeaderboardReward) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !props.canEdit,
                        onClick: () => props.onRemove?.(row.id)
                    })
                }
            ]
        };

        const totalRows = computed(() => props.total ?? props.rows.length);

        return { table, totalRows };
    }
});
